exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropzone {\r\n  width: 100%;\r\n  border: 1px dashed #cfd2d8;\r\n  border-radius: 3px;\r\n}\r\n\r\n.hotel-name {\r\n  color: blue;\r\n}\r\n\r\ni {\r\n  margin-right: .25rem;\r\n}\r\n\r\n.hotel-image {\r\n  width: 60px;\r\n  height: 50px;\r\n}\r\n\r\n.line:nth-child(2n+1) {\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.clickable {\r\n  cursor: pointer;\r\n}\r\n\r\n.clickable:hover {\r\n  box-shadow: 0px 0px 3px 2px rgba(0, 0, 255, 0.2);\r\n}\r\n\r\n.disabled {\r\n  pointer-events: none;\r\n  opacity: 0.5;\r\n  cursor: not-allowed !important;\r\n}\r\n\r\n.btn-primary {\r\n  height: 30px;\r\n  margin-left: 10px;\r\n  line-height: 15px;\r\n  margin-top: -5px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/pages/system-hotels/system-hotels.component.css
// module id = ../../../../../src/app/main/pages/system-hotels/system-hotels.component.css
// module chunks = main